export default "__VITE_ASSET__D6DkXzNE__"